var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_258_60766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(-90 0 20)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_258_60766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 10.625L13.3333 10.625L13.3333 9.375L17.0833 9.375L17.0833 10.625ZM14.8029 4.10417L12.1619 6.76604L11.2708 5.875L13.9327 3.23396L14.8029 4.10417ZM14.8029 15.8958L13.9327 16.766L11.2708 14.125L12.1619 13.234L14.8029 15.8958ZM4.16666 15.8333L5.06416 15.8333C5.13888 15.8333 5.20027 15.8093 5.24832 15.7613C5.29652 15.7132 5.32062 15.6517 5.32062 15.5769L5.32061 4.42313C5.32061 4.34827 5.29652 4.28681 5.24832 4.23875C5.20027 4.1907 5.13888 4.16667 5.06416 4.16667L4.16666 4.16667L4.16666 15.8333ZM6.57041 13.4904L7.55603 13.1602C7.6095 13.1388 7.65089 13.1068 7.6802 13.0642C7.70964 13.0214 7.72437 12.9733 7.72437 12.9198L7.72436 7.08021C7.72436 7.02674 7.70964 6.97861 7.6802 6.93583C7.65089 6.8932 7.6095 6.86118 7.55603 6.83979L6.57041 6.50959L6.57041 13.4904ZM8.97437 12.9198C8.97437 13.2435 8.88006 13.5366 8.69145 13.799C8.50284 14.0612 8.25367 14.2452 7.94395 14.351L6.57041 14.8077L6.57041 15.5769C6.57041 15.9924 6.42325 16.3474 6.12895 16.6419C5.83464 16.9362 5.47971 17.0833 5.06416 17.0833L2.91666 17.0833L2.91666 2.91667L5.06416 2.91667C5.47971 2.91667 5.83464 3.06382 6.12895 3.35813C6.42325 3.65257 6.57041 4.00757 6.57041 4.42313L6.57041 5.19229L7.9952 5.74209C8.28256 5.85639 8.51756 6.03903 8.7002 6.29C8.88298 6.54111 8.97436 6.82424 8.97437 7.13938L8.97437 12.9198Z",
    fill: "#3F3F46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/Sensor.2780a5523828f8264cc5223059d0b11b.svg";
export { ForwardRef as ReactComponent };